<template>
  <iframe
    v-if="url"
    id="userplayer"
    frameborder="0"
    :src="url + '&lang=Ru-ru&disableSupport=1'"
    allow="camera;microphone;fullscreen;accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture;display-capture;"
    allowusermedia
  ></iframe>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "LiveDigital",
  data: () => ({
    url: ``
  }),
  computed: {
    ...mapGetters(['EventDetail'])
  },
  created() {
    this.$axios(`/api/event/${this.EventDetail.id}/room-access/`, {method: 'GET'}).then((r) => {
      const res = r.data
      this.$set(this, 'url', `${res.url}`)
    }).catch((e) => {
      this.$set(this, 'url', `https://edu.livedigital.space/room/${this.EventDetail.webinar_id}/?participantName=${this.$route.query.email || ''}`)
    })
  }
};
</script>

<style lang="scss" scoped>
iframe {
  aspect-ratio: 16/9;
  width: 100%;

  @media screen and (max-width: 767px) {
    min-height: 400px;
  }
}
</style>